import React from "react";

import {
  apiShape,
  withApi,
  withConfiguration,
  withSession,
  withBackend,
  backendShape,
} from "../../context";
import { withUser } from "../../wrappers";
import { userShape, sessionShape } from "../../shapes";
import { NotFoundError } from "../../api";
import SeatInvitationModal from "./SeatInvitationModal";

type Props = {
  api?: apiShape;
  user?: userShape;
  configuration: {
    appId?: number;
    appName?: string;
  };
  session?: sessionShape;
  backend?: backendShape;
};

export function SeatInvitationCheck({
  api,
  user,
  configuration,
  session,
  backend,
}: Props) {
  const [seatInvitation, setSeatInvitation] = React.useState();

  const canAcceptInvitation = (subscription: $TSFixMe) => {
    if (
      subscription.type === "free" ||
      subscription.status === "open" ||
      subscription.status === "cancelled"
    ) {
      return true;
    }
    return false;
  };

  React.useEffect(() => {
    const loadData = async () => {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      const response = await api.get(
        "/subscription/seats",
        {
          include: "subscription.user",
          status: "pending,invited",
          client_application_id: `+${configuration.appId}`,
        },
        false,
      );
      const subscriptionSeat = response.subscription_seats.find(
        (seat: $TSFixMe) =>
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          seat.user?.id === user.id ||
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          seat.email?.toLowerCase() === user.email?.toLowerCase(),
      );
      /* istanbul ignore next */
      if (subscriptionSeat) {
        try {
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          const subscription = await backend.get("/subscription");
          if (canAcceptInvitation(subscription)) {
            setSeatInvitation(subscriptionSeat);
          }
        } catch (error) {
          if (error instanceof NotFoundError) {
            setSeatInvitation(subscriptionSeat);
          }
        }
      }
    };
    if (
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      session.activeSubscription === false ||
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      session.subscriptionType !== "paid"
    ) {
      loadData();
    }
  }, []);

  return (
    <div>
      {seatInvitation && (
        <SeatInvitationModal
          id="seat-popup"
          seat={seatInvitation}
          // @ts-expect-error TS(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
          appName={configuration.appName}
        />
      )}
    </div>
  );
}

export default withApi(
  // @ts-expect-error TS(2345) FIXME: Argument of type 'ForwardRefExoticComponent<Omit<R... Remove this comment to see the full error message
  withUser(withConfiguration(withSession(withBackend(SeatInvitationCheck)))),
);
